
<template>
  <div style="height: inherit">
    <div ref="canvas" id="canvas" class="h-100"></div>
    <div ref="contextWrapper">
      <vue-simple-context-menu
        :elementId="'shapeContextMenu'"
        :options="contextMenuOptions"
        :ref="'shapeContextMenu'"
        @option-clicked="optionClicked"
      >
      </vue-simple-context-menu>
    </div>
    <div>
      <list-espace-modal
        :tableauxListing="tableauxListing"
        :espacesListing="espacesListing"
        :dataListing="dataListing"
        :linkedData="schema.linkedData"
        @selected="handleSelect"
        @linkEspace="handleLinkEspace"
        @close="handleClose"
        ref="linkModal"
      />
      <delete-link-modal @deleteLink="handleDeleteLink" ref="deleteLinkModal" />
    </div>
  </div>
</template>
<script>
import Konva from "konva/lib/Core";
import { Rect } from "konva/lib/shapes/Rect";
import { Circle } from "konva/lib/shapes/Circle";
import { Transformer } from "konva/lib/shapes/Transformer";
import { Arrow } from "konva/lib/shapes/Arrow";
import { Image } from "konva/lib/shapes/Image";
import { Line } from "konva/lib/shapes/Line";
import { Text } from "konva/lib/shapes/Text";
import { actions } from "./helper/models";
import { EventBus, events } from "../../eventBus";
import { mapActions, mapGetters } from "vuex";
import listEspaceModal from "./modal/linkEspaceModal";
import deleteLinkModal from "./modal/deleteLinkModal";
import VueResizable from "vue-resizable";
import { formatNumber } from "../../utils/util";

const HISTORY_MAX_SIZE = 30;

import {
  decompose,
  getObjectSnappingEdges,
  getGuides,
  getLineGuideStops,
  haveIntersection,
  createArrow,
  drawArrow,
  createAttachAnchor,
  createText,
  createCircle,
  createRect,
  getShapeEdges,
  createTwoHeadsArrow,
  getRectCenter,
  createLineArrow,
  createTwoHeadsLineArrow,
  getMouseLocation,
  generateId,
  setNodeId,
  getNodeAttrs,
  createSchemaTree,
  isCmdKey,
  createLine,
  createDashedTwoHeadsArrow,
  createDashedArrow,
  schemaEvents,
  mapShapeToState,
  getShapeTopParent,
} from "./helper/index";

let clearTimeoutManager;

export default {
  props: {
    schemaData: null,
    tableauData: {
      type: Array,
      default: () => [],
    },
    schema: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    listEspaceModal,
    deleteLinkModal,
    VueResizable,
  },
  data() {
    return {
      selectionMarkers: [],
      dataLinks: [],
      initialPosition: null,
      hasModification: false,
      GUIDELINE_OFFSET: 5,
      columnDescription: null,
      stage: null,
      layer: null,
      transformer: null,
      currentAction: actions.SELECTION,
      selectionGroup: null,
      selection: [],
      text: null,
      groups: [],
      cmdKeyDown: false,
      contextMenuOptions: [],
      isDown: false,
      startX: null,
      scrollLeft: null,
      initialSize: {
        w: "100%",
        h: "100%",
      },
      tableauxListing: [],
      espacesListing: [],
      dataListing: [],
      keyMap: {
        17: false,
        16: false,
        46: false,
        67: false,
        86: false,
        89: false,
        91: false,
        90: false,
      },
      copiedObject: null,
      pastePosition: null,
      stroke: null,
      state: {},
      appHistory: [],
      appHistoryStep: 0,
      loaded: false,
      startMoving: false,
      Circle: Circle,
    };
  },
  watch: {
    selection: {
      handler(val) {
        let newVal = null;
        if (val.length) {
          newVal = {
            hasSelection: true,
            currentStyle: {
              stroke: val[val.length - 1].getAttr("stroke"),
              strokeWidth: val[val.length - 1].getAttr("strokeWidth"),
              fill: val[val.length - 1].getAttr("fill"),
            },
            currentType: val[val.length - 1].getAttr("shapeType"),
          };
          if (newVal.currentType === "text") {
            newVal = {
              ...newVal,
              fontFamily: val[val.length - 1].getAttr("fontFamily"),
              fontSize: val[val.length - 1].getAttr("fontSize"),
              fontStyle: val[val.length - 1].getAttr("fontStyle"),
              showTitle: val[val.length - 1].getAttr("showTitle") || false,
            };
          }
        } else {
          newVal = {
            hasSelection: false,
          };
        }
        this.setCurrentSelection(newVal);
      },
    },
    action(val) {
      this.currentAction = val;
    },
    selectAction(val) {
      if (val) {
        switch (val.type) {
          case "group":
            this.selectGroup(val.node);
            break;
          case "multiple":
            this.selectMultiple(val.node);
            break;
          case "connector":
            this.selectConnector(val.node);
            break;
          case "shape":
            this.selectShape(val.node);
            break;
        }
      }
    },
    hasModification(val) {
      EventBus.$emit(events.HAS_MODIFICATION, val);
    },
    dataLinks(value) {
      this.schema.shapeDataLinks = value;
    },
  },
  computed: {
    ...mapGetters(["action"]),
    eyeUrl() {
      return require("../../assets/images/Eye.svg");
    },
    selectAction() {
      return this.schema.selectAction;
    },
    schemaName() {
      return this.listSchema().find((el) => el.id === this.currentSchema()).nom;
    },
  },
  mounted() {
    EventBus.$on(events.SHEMA_SAVE, this.save)
      .$on(events.SHEMA_EXPORT, this.exportSchema)
      .$on(events.SAVE_CONFIRM, this.saveConfirm)
      .$on(schemaEvents.ON_UNDO, this._onUndo)
      .$on(schemaEvents.ON_REDO, this._onRedo)
      .$on(schemaEvents.ON_DELETE, this._onDeleteNode)
      .$on(schemaEvents.ON_STYLE_CHANGED, this._onStyleChanged);

    this.schema.tableauData = this.tableauData;
    this.renderSchemaTree(this.schemaData, this.readOnly);
    this.schema.updateLayerTree();
    this.initAppHistory();
  },
  async created() {
    window.applyAllStyle = true;
    Konva.showWarnings = false;
    Konva.showWarnings = false;
    document.addEventListener("keydown", this._keyDown);
    document.addEventListener("keyup", this._keyUp);
    this.tableauxListing = this.tableauData.map((el) => ({
      id: el.id,
      nom: el.nom,
    }));
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this._keyDown);
    document.removeEventListener("keyup", this._keyUp);
    this.schema.destroy();
    EventBus.$off(events.SHEMA_SAVE, this.save)
      .$off(events.SHEMA_EXPORT, this.exportSchema)
      .$off(events.SAVE_CONFIRM, this.saveConfirm)
      .$off(schemaEvents.ON_UNDO, this._onUndo)
      .$off(schemaEvents.ON_REDO, this._onRedo)
      .$off(schemaEvents.ON_DELETE, this._onDeleteNode)
      .$off(schemaEvents.ON_STYLE_CHANGED, this._onStyleChanged);
  },
  methods: {
    ...mapActions([
      "setRowId",
      "setCurrentSelection",
      "saveSchemaData",
      "setSaving",
      "setCurrentSchema",
      "getTableauxListById",
      "setEspaceFromTableau",
      "getColumnsDescription",
      "setAction",
      "setLayerTree",
    ]),
    ...mapGetters([
      "currentSchema",
      "tableauxList",
      "currentProject",
      "espacesList",
      "listSchema",
      "ficheTableauData",
    ]),
    initAppHistory() {
      this.appHistoryStep = 0;
      const layer = this.stage.getChildren()[0];
      for (const child of layer.children) {
        if (child.attrs.id) {
          this.state[child.attrs.id] = mapShapeToState(child);
        }
      }
      this.appHistory[0] = this.parseState(this.state);
    },
    debounce(callback, num = 0) {
      clearTimeout(clearTimeoutManager);
      clearTimeoutManager = setTimeout(callback, num);
    },
    _onUndo(_) {
      const nextStep = this.appHistoryStep - 1;
      if (nextStep < 0) return;
      this.state = this.appHistory[nextStep];
      this.appHistoryStep = nextStep;
      this.updateLayer();
    },
    _onRedo(_) {
      const nextStep = this.appHistoryStep + 1;
      if (nextStep >= this.appHistory.length) return;

      this.state = this.appHistory[nextStep];
      this.appHistoryStep = nextStep;
      this.updateLayer();
    },
    _onStyleChanged(schema) {
      const { selection } = schema;
      if (selection) {
        this._onSelectionChanged(selection);
      }
    },
    _onSelectionChanged(selection) {
      const ns = this.parseState(this.state);
      for (const shape of selection.concat(this.dataLinks)) {
        const shapeId = shape.attrs.id;
        if (shapeId) {
          ns[shapeId] = mapShapeToState(shape);
          // Handle group's children with relatives
          if (shapeId.startsWith("group")) {
            for (const child of shape.children) {
              this.handleRelatedShapes(ns, child);
            }
          }
        } else {
          const { children } = shape;
          if (children && children.length) {
            for (const child of children) {
              if (child.attrs.id) {
                ns[child.attrs.id] = mapShapeToState(child);
              }
            }
            this.handleRelatedShapes(ns, child);
          }
        }
        this.handleRelatedShapes(ns, shape);
      }
      setTimeout(() => this.addToHistory(ns, "_onSelectionChanged"), 100);
      this.dataLinks = [];
    },
    handleRelatedShapes(ns, shape) {
      const nodeId = shape.getAttr("id");
      const connectedArrows = this.stage.find((node) => {
        const to = node.getAttr("to");
        const toRelated = to && to.id === nodeId;
        const from = node.getAttr("from");
        const fromRelated = from && from.id === nodeId;
        return toRelated || fromRelated;
      });
      for (const arrow of connectedArrows) {
        const parent = arrow.getParent();
        if (parent && parent.getClassName() === "Group") {
            ns[parent.attrs.id][arrow.attrs.id];
          ns[parent.attrs.id][arrow.attrs.id] = mapShapeToState(arrow);
        } else {
          ns[arrow.attrs.id] = mapShapeToState(arrow);
        }
      }
    },
    _onDeleteNode(shape) {
      let selection = [];
      const type = shape.getType();
      if (type === "Group") {
        selection = this.schema.selection;
      } else {
        selection = [shape];
      }
      this._deleteNode(selection);
    },
    _deleteNode(selection) {
      const ns = this.parseState(this.state);
      for (const shape of selection) {
        delete ns[shape.attrs.id];
      }
      this.addToHistory(ns, "_onDeleteNode");
    },
    updateLayer() {
      this.schema.currentLayer.destroyChildren();
      for (const key of Object.keys(this.state)) {
        const shape = this.renderShape(this.state[key], !this.readOnly);
        if (shape) {
          this.schema.currentLayer.add(shape);
          this.setRenderredShapedEvents(shape, this.stage);
        } else {
          if (this.state[key].attrs.shapeType === "eye") {
            Image.fromURL(this.eyeUrl, (image) =>
              this.renderImage(
                this.state[key].attrs,
                image,
                this.schema.currentLayer
              )
            );
          }
        }
      }
      this.schema.currentLayer.batchDraw();
      this.schema.updateLayerTree();
    },
    renderShape(rawShape, draggable, shouldGenerateId = false) {
      let shape;
      if (rawShape.type === "group") {
        shape = new Konva.Group(rawShape.attrs);
        for (const childShape of rawShape.children) {
          const renderredShaped = this.renderShape(
            childShape,
            false,
            shouldGenerateId
          );
          shape.add(renderredShaped);
        }
        if (shouldGenerateId) setNodeId(shape);
        shape.setAttr("draggable", draggable);
        this.addNodeListener(shape, "dragmove", this._groupMove);
        this.addNodeListener(shape, "dragend transform", this._groupMoveEnd);
      } else {
        shape = this.convertToSchemaNode(rawShape);
        if (shape) {
          if (shouldGenerateId) setNodeId(shape);
          shape.setAttr("draggable", draggable);
          this.setNodeListener(shape);
        }
      }
      return shape;
    },

    onStateChange(shape) {
      if (!shape) return;
      const ns = this.parseState(this.state);
      if (Array.isArray(shape)) {
        for (const s of shape) {
          ns[s.attrs.id] = mapShapeToState(s);
        }
      } else {
        ns[shape.attrs.id] = mapShapeToState(shape);
      }
      this.addToHistory(ns, "onStateChange");
    },
    onStateChangeWithGroup(shape, selection) {
      const ns = this.parseState(this.state);
      ns[shape.attrs.id] = mapShapeToState(shape);
      for (const child of selection) {
        delete ns[child.attrs.id];
        const mappedChild = mapShapeToState(child);
        const findIndex = ns[shape.attrs.id].children.findIndex(
          (e) => e.attrs.id === mappedChild.attrs.id
        );
        if (findIndex === -1) {
          ns[shape.attrs.id].children.push(mappedChild);
        } else {
          ns[shape.attrs.id].children[findIndex] = mappedChild;
        }
      }
      this.addToHistory(ns, "onStateChangeWithGroup");
    },
    onUngroup(parent, layer, selection) {
      for (const child of selection) {
        const matrix = child.getAbsoluteTransform().getMatrix();
        const attrs = decompose(matrix);
        const element = mapShapeToState(child);
        const shape = this.renderShape(element, true);
        if (shape) {
          shape.setAttrs(attrs);
          if (
            !(
              shape.getClassName() === "Arrow" ||
              shape.getClassName() === "Line" ||
              shape.getClassName() === "Shape"
            )
          ) {
            shape.setAttr("anchors", []);
          }
          layer.add(shape);
          this.schema.updateLayerTree();
          this.setRenderredShapedEvents(shape, this.stage);
        } else {
          if (element.attrs.shapeType === "eye") {
            Image.fromURL(this.eyeUrl, (image) =>
              this.renderImage(element.attrs, image, this.schema.currentLayer)
            );
          }
        }
      }
      parent.destroy();
      this.stage.find("Transformer").destroy();
      this.schema.clearSelection();
      this.schema.updateLayerTree();
    },
    setRenderredShapedEvents(shape, stage) {
      if (shape.id().startsWith("shape")) {
        const edges = getShapeEdges(shape, stage);
        Object.keys(edges).forEach((key) =>
          createAttachAnchor(edges[key].x, edges[key].y, shape, key)
        );
        this.updateAnchors(shape);
      }
    },
    onStateChangeWithUngroup(shape, selection) {
      const ns = this.parseState(this.state);
      delete ns[shape.attrs.id];
      for (const child of selection) {
        ns[child.attrs.id] = mapShapeToState(child);
      }
      this.addToHistory(ns, "onStateChangeWithUngroup");
    },
    addToHistory(state, source) {
      this.appHistory = this.appHistory.slice(0, this.appHistoryStep + 1);
      const ns = this.parseState(state);
      let history = this.appHistory.concat([ns]);
      if (history.length > HISTORY_MAX_SIZE) {
        history = history.slice(1);
      } else {
        this.appHistoryStep += 1;
      }
      this.appHistory = history;
      this.state = ns;
    },
    renderImage(attrs, node, parent, draggable = true, id) {
      parent.add(node);
      const { image, ...others } = attrs;
      const nAttrs = {
        ...others,
        draggable,
      };
      if (id) {
        nAttrs.id = id;
      }
      node.setAttrs(nAttrs);
      this.addNodeListener(node, "transform", (e) =>
        this.debounce(() => this.onStateChange(e.target), 50)
      );
      this.addContextMenuListener(node, this.contextMenu);
      node.getLayer().batchDraw();
    },
    _mapAnchors(origin, target) {
      const hasChildren = origin.children.length > 0;
      if (hasChildren) {
        for (let i = 0; i < origin.children.length; i++) {
          if (origin.children[i].attrs.anchors) {
            target.children[i].attrs.anchors = origin.children[i].attrs.anchors;
          }
          this._mapAnchors(origin.children[i], target.children[i]);
        }
      }
    },
    parseState(state) {
      const ns = JSON.parse(JSON.stringify(state));
      for (const key in state) {
        this._mapAnchors(state[key], ns[key]);
        ns[key].attrs.anchors = state[key].attrs.anchors;
      }
      return ns;
    },
    async save() {
      this.removeHighLights();
      this.schema.refresh();
      const payload = {
        schemaId: this.currentSchema(),
        data: createSchemaTree(this.stage, this.schema.lastNum),
        tableauUpdate: this.ficheTableauData(),
      };
      this.setSaving(true);
      await this.saveSchemaData(payload);
      this.hasModification = false;
      this.setSaving(false);
    },
    setDragBoundFunc(node, ratio) {
      node.dragBoundFunc(function (pos, e) {
        const { width, height } = this.getStage().getAttrs();
        let {
          x,
          y,
          width: swidth,
          height: sheight,
        } = this.getClientRect({ relativeTo: this.getStage() });
        const move = {
          x: 0,
          y: 0,
        };

        const _lastPos = Object.assign({ x: 0, y: 0 }, this._lastPos);
        if (_lastPos) {
          move.x = pos.x - _lastPos.x;
          move.y = pos.y - _lastPos.y;
        }

        x += move.x;
        y += move.y;

        if (y < 0 || y + sheight > height) {
          pos.y = _lastPos.y;
        }

        if (x < 0 || x + swidth > width) {
          pos.x = _lastPos.x;
        }

        return {
          x: pos.x,
          y: pos.y,
        };
      });
    },
    exportSchema() {
      this.removeHighLights();
      this.schema.refresh();
      const dataUrl = this.stage.toDataURL({
        mimeType: "image/png",
        pixelRatio: 2,
      });
      this.$emit("export", {
        src: dataUrl,
        fileName: `${this.schemaName}.png`,
      });
    },
    async saveConfirm(currMod, next) {
      if (currMod === "SF") {
        this.removeHighLights();
        this.schema.refresh();
        const payload = {
          schemaId: this.currentSchema(),
          data: createSchemaTree(this.stage, this.schema.lastNum),
          tableauUpdate: this.ficheTableauData(),
        };
        this.setSaving(true);
        await this.saveSchemaData(payload);
        this.hasModification = false;
        this.setSaving(false);
        next();
      }
    },
    handleClose() {
      this.dataListing = [];
      this.espacesListing = [];
    },
    handleDeleteLink({ selection, all }) {
      if (selection.length) {
        const links = selection.map((el) => {
          return this.stage
            .find((node) => {
              return node && node.getAttr("id").toString() === el.trim();
            })
            .toArray()[0];
        });
        this._deleteNode(links);
        if (all) {
          let relatedNode = this.state[links[0].attrs.linkTo];
          if (relatedNode) {
            relatedNode = this.stage
              .find((node) => node && node.attrs.id === relatedNode.attrs.id)
              .toArray()[0];
            if (relatedNode) {
              delete relatedNode.attrs.theName;
            }
          }
        }
        links.forEach((el) => {
          el.destroy();
        });
        this.schema.updateLayerTree();
        this.schema.refresh();
      }
    },
    getTableauData(idTableau, key, rowNo, rowId = null) {
      const tableau = this.tableauData.find(
        (el) => el.id + "" === idTableau + ""
      );
      const keyIndex = tableau.columns.findIndex((col) => col.key === key);
      let id, res;
      if (!tableau.rows || !tableau.rows[rowNo] || !tableau.rows[rowNo].id) {
        id = generateId();
        this.setRowId({ onglet: idTableau, ligne: rowNo, id });
      } else if (
        tableau.rows &&
        tableau.rows[rowNo] &&
        tableau.rows[rowNo].id
      ) {
        id = tableau.rows[rowNo].id;
      }

      if (!rowId) {
        const data = tableau.data[rowNo][keyIndex];
        res = {
          title: tableau.data[0][keyIndex],
          data: data,
          unit: tableau.columns[keyIndex].unit,
          rowId: id,
          rowNo,
        };
        if (("" + data).startsWith("=")) {
          if (tableau.formulaValue && data && ("" + data).startsWith("=")) {
            const jexcel = require("jexcel");
            const colName = jexcel.getColumnNameFromId([keyIndex, rowNo]);
            // eslint-disable-next-line no-eval
            res.data = isNaN(tableau.formulaValue[colName])
              ? Math.round(eval(data.split("=")[1]))
              : tableau.formulaValue[colName];
          }
        }
        if (tableau.columns[keyIndex].displayFormat === "money") {
          res.data = formatNumber(res.data);
        }
        return res;
      }

      if (id !== rowId) {
        rowNo = tableau.rows.findIndex((el) => {
          if (el) {
            return el.id === rowId;
          }
        });
        id = rowId;
      }
      const data = tableau.data[rowNo][keyIndex];
      res = {
        title: tableau.data[0][keyIndex],
        data: data,
        unit: tableau.columns[keyIndex].unit,
        rowId: id,
        rowNo,
      };
      if (("" + data).startsWith("=")) {
        if (tableau.formulaValue && data && ("" + data).startsWith("=")) {
          const jexcel = require("jexcel");
          const colName = jexcel.getColumnNameFromId([keyIndex, rowNo]);
          // eslint-disable-next-line no-eval
          res.data = isNaN(tableau.formulaValue[colName])
            ? Math.round(eval(data.split("=")[1]))
            : tableau.formulaValue[colName];
        }
      }
      if (tableau.columns[keyIndex].displayFormat === "money") {
        res.data = formatNumber(res.data);
      }
      return res;
    },
    handleLinkEspace(shapeId, data) {
      const linkTo = this.stage.find(`#${shapeId}`).toArray()[0];
      let position = {
        x: linkTo.getAttr("x"),
        y: linkTo.getAttr("y"),
      };
      const layer = linkTo.getLayer();
      linkTo.setAttr("theName", "Hall d'entrée");
      linkTo.setAttr("createdAtIndex", 0);
      const shapes = [];
      data.forEach((el, index) => {
        const { rowNo, idTableau, key } = el;
        const tData = this.getTableauData(idTableau, key, rowNo);
        this.schema.addLinkedData(idTableau, key, rowNo);
        const shape = new Text(
          createText({
            x: position.x,
            y: position.y,
            shapeType: "text",
            text: `${tData.data} ${tData.unit ? tData.unit : ""}`,
            theName: `${tData.data} ${tData.unit ? tData.unit : ""}`,
            linkTo: shapeId,
            zIndex: linkTo.attrs.zIndex,
            ...el,
            rowNo: tData.rowNo,
            rowId: tData.rowId,
            showTitle: false,
            createdAt: linkTo.attrs.createdAt,
            createdAtIndex: index + 1,
          })
        );

        shape.setAttr("id", generateId("dataLink"));
        position.y += shape.padding() + 10;
        this.addContextMenuListener(shape, this.contextMenu);
        this.addNodeListener(shape, "transform", () =>
          this._customTextTransform(shape)
        );
        shapes.push(shape);
        layer.add(shape);
      });
      this.onStateChange(shapes);
      layer.batchDraw();
      this.schema.updateLayerTree();
      EventBus.$emit(events.RESET_FILTER);
    },
    async handleSelect(id, type) {
      if (type === "tableau") {
        const currTab = this.handleOnSelectTableau(id);
        this.columnDescription = {
          columns: currTab.columns,
          headers: currTab.data[0],
          idTableau: id,
        };
      } else if (type === "espace") {
        this.dataListing = [];

        this.dataListing = this.columnDescription.headers
          .map((el, index) => {
            return {
              key: this.columnDescription.columns[index].key,
              title: el,
              rowNo: id,
              idTableau: this.columnDescription.idTableau,
            };
          })
          .filter((el) => el.title.trim());
      }
    },
    handleOnSelectTableau(idTableau) {
      /* await this.setEspaceFromTableau(idTableau)
      this.espacesListing = this.espacesList() */
      const currTab = this.tableauData.find(
        (el) => el.id + "" === idTableau + ""
      );
      let columns = currTab.columns;
      if (!columns) {
        columns = [];
      }
      const codeIndex = columns.findIndex((el) => el.key === "H0");
      const denIndex = columns.findIndex((el) => el.key === "H1");
      this.espacesListing = currTab.data
        .map((esp, index) => ({
          id: index,
          nom: esp[denIndex],
          code: esp[codeIndex],
          idTableau,
        }))
        .filter((el, index) => index && el.nom && el.code);
      return currTab;
    },
    handleZoom(scale) {
      this.stage.width(this.initialSize.w * scale);
      this.stage.height(this.initialSize.h * scale);
      this.stage.scaleX(scale);
      this.stage.scaleY(scale);
      this.stage.draw();
    },
    renderSchemaTree(schematree, readOnly = false) {
      this.schema.initStage();
      const children = this.schema.stage.getChildren();
      this.stage = this.schema.stage;
      this.addNodeListener(this.stage, "mousedown", this._stageMouseDown);
      this.addNodeListener(this.stage, "mouseover", this._stageMouseover);
      this.addNodeListener(this.stage, "mouseout", this._stageMouseout);
      this.addNodeListener(this.stage, "dragmove", this._stageDragMove);
      this.addNodeListener(this.stage, "dragend", this._stageDragEnd);
      this.addContextMenuListener(this.stage, this.contextMenu);
      if (!schematree) {
        const layer = new Konva.Layer({
          name: `Calque`,
          isDefault: true,
        });
        this.stage.add(layer);
        const children = this.stage.getChildren();
        this.schema.currentLayer = layer;
      } else {
        if (!schematree.layerIndex) {
          schematree.layerIndex = 0;
        }
        this.traverseSchemaTree(schematree, this.stage, readOnly);
      }
      this.schema.currentLayer = this.stage.getChildren().toArray()[0];
      this.schema.lastNum = schematree ? schematree.layerIndex : 1;
      this.schema.refresh();
    },
    traverseSchemaTree(
      node,
      parent,
      readOnly = false,
      parentNodeType = ["Stage", "Layer", "Group"]
    ) {
      let isDraggable = !readOnly;
      node.children.forEach((el) => {
        let child = null;
        if (parentNodeType.indexOf(el.type) > -1) {
          switch (el.type) {
            case "Layer":
              const layer = new Konva.Layer(el.attrs);
              if ((el.attrs && el.attrs.isDefault) || node.layerIndex === 1) {
                layer.setAttr("isDefault", true);
              }
              parent.add(layer);
              this.traverseSchemaTree(el, layer, readOnly);
              break;
            case "Group":
              child = new Konva.Group(el.attrs);
              const isParentGroup = parent.getType() === "Group";
              if (!isParentGroup) {
                this.addNodeListener(child, "dragmove", this._groupMove);
                this.addNodeListener(
                  child,
                  "dragend transform",
                  this._groupMoveEnd
                );
              }
              parent.add(child);
              this.traverseSchemaTree(el, child, readOnly);
              break;
          }
        } else {
          const _loaded = this.loaded;
          if (el.type === "eye") {
            Image.fromURL(this.eyeUrl, (node) => {
              this.renderImage(el.attrs, node, parent);
              if (!_loaded) {
                this.state[el.attrs.id] = mapShapeToState(node);
              }
            });
          } else {
            child = this.convertToSchemaNode(el, parent);
            if (child == null) {
              return;
            }

            this.setDragBoundFunc(child);
            if (this.readOnly) {
              child.setAttr("draggable", false);
            }
            parent.add(child);
            if (el.type === "rect" || el.type === "circle") {
              child.setAttr("anchors", []);
              const edges = getShapeEdges(child, this.stage);
              Object.keys(edges).forEach((key) =>
                createAttachAnchor(edges[key].x, edges[key].y, child, key)
              );
            }
          }
        }
      });
    },
    convertToSchemaNode(element, parent) {
      const {
        x,
        y,
        width,
        height,
        shapeType,
        id,
        pointerWidth,
        fill,
        ...others
      } = element.attrs;
      let shape, _this;
      _this = this;
      switch (element.type) {
        case "rect":
          shape = new Rect({ ...element.attrs });
          this.setNodeListener(shape);
          break;
        case "circle":
          shape = new Circle({ ...element.attrs });
          this.setNodeListener(shape);
          break;
        case "customText":
          shape = new Text({ ...element.attrs });
          shape.align("center");
          this.addNodeListener(shape, "dblclick", this._customTextDblclick);
          this.addNodeListener(shape, "transform", () =>
            this._customTextTransform(shape)
          );
          break;
        case "text":
          try {
            const { rowNo, idTableau, key, showTitle, rowId } = element.attrs;
            const tdata = this.getTableauData(idTableau, key, rowNo, rowId);
            this.schema.addLinkedData(idTableau, key, rowNo);
            shape = new Text({ ...element.attrs });
            shape.align("center");
            const text = showTitle
              ? `${tdata.title}: ${tdata.data} ${tdata.unit ? tdata.unit : ""}`
              : `${tdata.data} ${tdata.unit ? tdata.unit : ""}`;
            shape.text(text);
            shape.setAttr("rowNo", tdata.rowNo);
            shape.setAttr("rowId", tdata.rowId);
            this.addNodeListener(shape, "transform", () =>
              this._customTextTransform(shape)
            );
          } catch (e) {
            shape = null;
          }
          break;
        case "customDoubleArrow":
          shape = new Konva.Shape(
            createTwoHeadsLineArrow({
              x,
              y,
              width,
              pointerWidth: pointerWidth || 10,
              shapeType,
              id,
            })
          );
          shape.setAttrs(others);
          shape.sceneFunc(function (context, shape) {
            context.beginPath();
            context.moveTo(shape.x(), shape.y());
            const points = shape.getAttr("points");
            drawArrow(
              context,
              points[0],
              points[1],
              points[2],
              points[3],
              shape.getAttr("pointerWidth"),
              "double"
            );
            context.fillStrokeShape(shape);
          });
          shape.getSelfRect = function () {
            const [x, y, x2, y2] = shape.getAttr("points");
            const posy = y2 < y ? y2 : y;
            return {
              x: x,
              y: posy - shape.getAttr("pointerWidth"),
              width: x2 - x,
              height: Math.abs(y2 - y) + shape.getAttr("pointerWidth") * 2,
            };
          };
          this.addNodeListener(shape, "dragmove", this._arrowMove);
          this.addNodeListener(shape, "dragend", this._arrowMoveEnd);
          break;
        case "customArrow":
          shape = new Konva.Shape(
            createLineArrow({
              x,
              y,
              width,
              pointerWidth: pointerWidth || 10,
              shapeType,
              id,
            })
          );
          shape.setAttrs(others);
          shape.sceneFunc(function (context, shape) {
            context.beginPath();
            context.moveTo(shape.x(), shape.y());
            const points = shape.getAttr("points");
            drawArrow(
              context,
              points[0],
              points[1],
              points[2],
              points[3],
              shape.getAttr("pointerWidth")
            );
            context.fillStrokeShape(shape);
          });
          shape.getSelfRect = function () {
            const [x, y, x2, y2] = shape.getAttr("points");
            const posy = y2 < y ? y2 : y;
            return {
              x: x,
              y: posy - shape.getAttr("pointerWidth"),
              width: x2 - x,
              height: Math.abs(y2 - y) + shape.getAttr("pointerWidth") * 2,
            };
          };
          this.addNodeListener(shape, "dragmove", this._arrowMove);
          this.addNodeListener(shape, "dragend", this._arrowMoveEnd);
          break;
        case "arrow":
        case "dashedArrow":
        case "doubleArrow":
        case "doubleDashedArrow":
          shape = new Arrow({ ...element.attrs });
          if (shape.strokeWidth() <= 2) {
            shape.hitStrokeWidth(3);
          }
          this.addNodeListener(shape, "dragmove", this._arrowMove);
          this.addNodeListener(shape, "dragend", this._arrowMoveEnd);
          break;
        case "line":
          shape = new Line({ ...element.attrs });
          if (shape.strokeWidth() <= 2) {
            shape.hitStrokeWidth(3);
          }
          this.addNodeListener(shape, "dragmove", this._arrowMove);
          this.addNodeListener(shape, "dragend", this._arrowMoveEnd);
          break;
      }
      if (fill === "#FFF") {
        shape.fill("#FFFFFF");
      }

      return shape;
    },
    setNodeListener(node) {
      const type = node.getAttr("shapeType");
      node.off("contextmenu");
      if (type === "rect" || type === "circle" || type === "eye") {
        node.off("dragstart dragmove dragend transform");
        this.addNodeListener(node, "dragstart", this._stageMoveStart);
        this.addNodeListener(node, "dragmove", this._shapeMove);
        this.addNodeListener(node, "dragend", this._shapeMoveEnd);
        this.addNodeListener(node, "transform", this._shapeTransform);
      } else if (node.id().startsWith("connector")) {
        this.addNodeListener(node, "dragmove", this._arrowMove);
        this.addNodeListener(node, "dragend", this._arrowMoveEnd);
      }
      this.addContextMenuListener(node, this.contextMenu);
    },

    copyNode(node) {
      if (node) {
        let copy;
        if (
          node.getAttr("shapeType") &&
          node.getAttr("shapeType").startsWith("custom")
        ) {
          const type = node.getAttr("shapeType");
          const attrs = getNodeAttrs(node, type, this.stage);
          const element = {
            attrs,
            type,
          };
          copy = this.convertToSchemaNode(element);
          copy.setAttr("from", null);
          copy.setAttr("to", null);
        } else {
          copy = node.clone();
        }
        return {
          node: copy,
          layer: node.getLayer(),
        };
      } else {
        return null;
      }
    },
    pasteNode(copiedNode, position = null) {
      if (this.copiedObject) {
        const copy = this.copyNode(copiedNode.node);
        const shape = copy.node;
        const layer = copiedNode.layer;

        if (
          shape.getAttr("shapeType") &&
          shape.getAttr("shapeType").startsWith("custom") &&
          shape.id().startsWith("connector")
        ) {
          const [x, y, x2, y2] = shape.getAttr("points");
          const newX = position ? position.x : x + 10;
          const newY = position ? position.y : y + 10;
          shape.setAttr("points", [newX, newY, x2 - x + newX, y2 - y + newY]);
        } else {
          shape.x(position ? position.x : shape.x() + 10);
          shape.y(position ? position.y : shape.y() + 10);
        }
        this.schema.clearSelection();

        if (shape.getType() === "Group") {
          const newGroup = new Konva.Group({
            draggable: true,
            createdAt: Date.now(),
          });
          const children = shape
            .getChildren()
            .toArray()
            .map((el) => {
              const clone = this.copyNode(el).node;
              clone.remove();
              setNodeId(clone);
              this.setNodeListener(clone);
              const { x: sx, y: sy } = getNodeAttrs(
                clone,
                clone.getAttr("shapeType"),
                this.stage
              );

              clone.x(sx + 10);
              clone.y(sy + 10);
              return clone;
            });
          if (this.stage.findOne(".selectionGroup")) {
            this.ungroup(this.selectionGroup);
          }
          newGroup.add(...children);
          layer.add(newGroup);
          this.schema.select("group", newGroup);
          this.schema.updateLayerTree();
          copiedNode = this.copyNode(newGroup);

          if (typeof window.mustUngroup !== "undefined" && window.mustUngroup) {
            this.ungroup(newGroup);
            window.mustUngroup = false;
          }
        } else {
          setNodeId(shape);
          this.setNodeListener(shape);
          layer.add(shape);
          this.schema.updateLayerTree();
          if (
            shape.getClassName() === "Arrow" ||
            shape.getClassName() === "Line" ||
            shape.getClassName() === "Shape"
          ) {
            this.schema.select("connector", shape);
          } else {
            const edges = getShapeEdges(shape, this.stage);
            shape.setAttr("anchors", []);
            Object.keys(edges).forEach((key) =>
              createAttachAnchor(edges[key].x, edges[key].y, shape, key)
            );
            this.schema.select("shape", shape);
          }
          copiedNode = this.copyNode(shape);
        }
        layer.draw();
        return copiedNode;
      }
    },
    _keyDown(e) {
      let hasChange = false;
      if (e.keyCode in this.keyMap) {
        this.keyMap[e.keyCode] = true;
        if (this.keyMap[17] && this.keyMap[67]) {
          e.preventDefault();
          const node = this.schema.selection[0];
          if (node) {
            this.optionClicked({
              option: { action: "copy-shape" },
              item: node,
            });
            hasChange = true;
          }
        } else if (this.keyMap[17] && this.keyMap[86]) {
          e.preventDefault();
          this.optionClicked({
            option: { action: "paste-shape" },
          });
          hasChange = true;
        } else if (this.keyMap[17] && this.keyMap[89]) {
          // Redo
          e.preventDefault();
          this._onRedo(e);
          hasChange = true;
        } else if (this.keyMap[17] && this.keyMap[90]) {
          // Undo
          e.preventDefault();
          this._onUndo(e);
          hasChange = true;
        }
      }

      let item;

      if (this.schema.selection.length > 1) {
        item = this.transformer ? this.transformer.getNode() : null;
        if (item) {
          for (let i = 0; i < item.children.length; i++) {
            if (
              document.querySelector(
                '[value="' + item.children[i].attrs.theName + '"]'
              )
            ) {
              document
                .querySelector(
                  '[value="' + item.children[i].attrs.theName + '"]'
                )
                .closest("li")
                .classList.remove("generated");
              document.querySelector(
                '[value="' + item.children[i].attrs.theName + '"]'
              ).checked = false;
            }
          }
        }
      } else {
        item = this.schema.selection.length ? this.schema.selection[0] : null;
        if (item) {
          if (document.querySelector('[value="' + item.attrs.theName + '"]')) {
            document
              .querySelector('[value="' + item.attrs.theName + '"]')
              .closest("li")
              .classList.remove("generated");
            document.querySelector(
              '[value="' + item.attrs.theName + '"]'
            ).checked = false;
          }
        }
      }

      if (e.keyCode === 46) {
        if (item) {
          this._onDeleteNode(item);
          this.schema.deleteNode(item);
          hasChange = true;
        }
      }
      if (
        typeof this.stage !== "undefined" &&
        typeof item !== "undefined" &&
        item
      ) {
        e.preventDefault();
        if (e.keyCode === 40) {
          item.y(item.y() + 2);
        } else if (e.keyCode === 38) {
          item.y(item.y() - 2);
        } else if (e.keyCode === 39) {
          item.x(item.x() + 2);
        } else if (e.keyCode === 37) {
          item.x(item.x() - 2);
        }
        hasChange = true;
      }
      this._arrowMove({ target: item });
      this.updateAnchors(item);
      if (hasChange) {
        this.onStateChange(item);
      }
    },
    _keyUp(e) {
      if (e.keyCode in this.keyMap) {
        this.keyMap[e.keyCode] = false;
      }
    },
    selectGroup(group) {
      this.selection = [];
      this.transformer = new Transformer();
      const layer = group.getLayer();

      if (layer) {
        layer.add(this.transformer);
        this.initialPosition = {
          x: group.x(),
          y: group.y(),
        };
        this.transformer.attachTo(group);
        this.schema.formatSelectionData(
          this.schema.selection[this.schema.selection.length - 1]
        );
        layer.draw();
      }
    },
    selectMultiple(node) {
      this.transformer = new Transformer();
      if (!this.stage.findOne(".selectionGroup")) {
        if (
          node.id().startsWith("connector") &&
          this.schema.selection.length === 1
        ) {
          this.selectConnector(node);
          return;
        }
        this.selectionGroup = new Konva.Group({
          draggable: true,
          name: "selectionGroup",
          shapeType: "group",
          createdAt: Date.now(),
        });
        this.addNodeListener(
          this.selectionGroup,
          "dragmove",
          this._selectionMove
        );
        this.addNodeListener(
          this.selectionGroup,
          "dragstart",
          this._selectionMoveStart
        );
        this.addNodeListener(
          this.selectionGroup,
          "dragend",
          this._selectionMoveEnd
        );
        node.getLayer().add(this.selectionGroup);

        window.mustUngroup = true;
      }

      if (node.getLayer() === this.selectionGroup.getLayer()) {
        if (this.schema.selection.length > 0) {
          this.schema.selection.forEach((el) => {
            el.draggable(false);
          });
        }
        if (!this.selectionGroup.hasChildren()) {
          this.schema.selection.sort((a, b) => a.zIndex() - b.zIndex());
          this.schema.selection.forEach((el) => {
            this.selectionGroup.add(el);
          });
        } else {
          this.selectionGroup.add(node);
          this.selectionGroup.children.sort(
            (a, b) => b.height() * b.width() - a.height() * a.width()
          );
          this.selectionGroup._setChildrenIndices();
        }
        if (node.getAttr("id").startsWith("shape")) {
          this.dataLinks = [...this.dataLinks, ...this.findLink(node)];
          this.dataLinks.forEach((link) => {
            link.moveToTop();
          });
        }
        this.initialPosition = {
          x: this.selectionGroup.x(),
          y: this.selectionGroup.y(),
        };
        // this.selectionMarkers = [...this.selectionMarkers, this.createSelectionMarker(node)]
        this.selectionGroup.getLayer().add(this.transformer);
        this.transformer.attachTo(this.selectionGroup);
        this.transformer.forceUpdate();
        this.schema.formatSelectionData(node);
        node.getLayer().draw();
      }
    },
    createSelectionMarker(node) {
      const _this = this;
      function findCenter(node) {
        if (node.getClassName() === "Rect") {
          return getRectCenter(node, _this.stage);
        } else if (node.getClassName() === "Circle") {
          return {
            x: node.x(),
            y: node.y(),
          };
        } else if (node.id().startsWith("connector")) {
          const [x, y, x2, y2] = node.getAttr("points");
          return {
            x: x + (x2 - x) / 2,
            y: y + (y2 - y) / 2,
          };
        }
        return null;
      }

      const { x, y } = findCenter(node);
      const marker = new Circle({
        x,
        y,
        name: "marker",
        radius: 5,
        fill: "#e91e63",
        opacity: 0.5,
        draggable: false,
        shapeType: "marker",
      });

      marker.x(x);
      marker.y(y);
      const layer = node.getLayer();
      layer.add(marker);
      return marker;
    },
    selectConnector(node) {
      // this.showAttachAnchors(true)
      if (this.stage.findOne(".selectionGroup")) {
        this.ungroup(this.selectionGroup);
      }
      this.schema.formatSelectionData(node);
      const points = node.getAttr("points");
      this.createSelector(
        points[0] + node.x(),
        points[1] + node.y(),
        node,
        "start-anchor"
      );
      this.createSelector(
        points[2] + node.x(),
        points[3] + node.y(),
        node,
        "end-anchor"
      );
      node.getLayer().draw();
    },
    selectShape(node) {
      if (node.hasName("selector")) return;
      if (this.stage.findOne(".selectionGroup")) {
        this.ungroup(this.selectionGroup);
      }
      this.removeHighLights();

      if (node.getAttr("shapeType") === "customText") {
        this.transformer = new Transformer({
          enabledAnchors: node.getAttr("enabledAnchors"),
          boundBoxFunc: function (oldBox, newBox) {
            newBox.width = Math.max(30, newBox.width);
            return newBox;
          },
        });
      } else {
        this.transformer = new Transformer({
          enabledAnchors: node.getAttr("enabledAnchors"),
        });
      }
      // should hilghlight links
      if (node.id().startsWith("shape")) {
        this.dataLinks = this.highlightDataLink(node);
        this.initialPosition = {
          x: node.x(),
          y: node.y(),
        };
      } else if (node.id().startsWith("dataLink")) {
        this.highlightNode(node);
      }
      this.schema.formatSelectionData(node);
      const layer = node.getLayer();
      layer.add(this.transformer);
      this.transformer.attachTo(node);
      layer.draw();
    },
    highlightDataLink(node) {
      const links = this.findLink(node);
      if (links) {
        links.forEach((el) => {
          el.shadowColor("#0d47a1");
          el.textDecoration("underline");
          el.shadowBlur(10);
          el.shadowOpacity(1);
        });
      }
      return links;
    },
    highlightNode(dataLink) {
      const nodeId = dataLink.getAttr("linkTo");
      const node = this.stage.find(`#${nodeId}`);
      node.shadowColor("black");
      node.shadowBlur(8);
      node.shadowOffset({ x: 5, y: 5 });
      node.shadowOpacity(0.5);
    },
    removeHighLights() {
      this.stage
        .find((el) => {
          return el.id().startsWith("dataLink") || el.id().startsWith("shape");
        })
        .toArray()
        .forEach((el) => {
          el.shadowOpacity(0);
          if (el.getClassName() === "Text") {
            el.textDecoration("");
          }
        });
    },
    _stageMouseDown(e) {
      if (this.readOnly) {
        return;
      }
      if (e.evt.button === 0) {
        const { x, y } = getMouseLocation(e, this.stage);
        let shape = null;
        this.hasModification = true;

        var espaces = document.querySelectorAll(".input-espaces");
        var selectedEspacesValue = [];
        var selectedEspaces = [];
        var numOfCheckedChekboxes = 0;

        for (let i = 0; i < espaces.length; i++) {
          if (espaces[i].checked) {
            numOfCheckedChekboxes++;
            selectedEspacesValue.push(espaces[i].value);
            selectedEspaces.push(espaces[i]);
          }
        }

        if (numOfCheckedChekboxes === 0) {
          numOfCheckedChekboxes = 1;
        }
        switch (this.currentAction) {
          case actions.NAVIGATE:
            break;
          case actions.SELECTION:
            if (e.target.getAttr("name").endsWith("_anchor")) {
              break;
            }
            if (e.target.getAttr("name").includes("selector")) {
              break;
            }

            this.initialPosition = null;
            this.clearSelector();
            this.removeHighLights();
            this.stage.find("Transformer").destroy();
            const cmd = isCmdKey(e);
            if (e.target === this.stage) {
              this.stage.find("Transformer").destroy();
              const selectionGroup = this.stage.findOne(".selectionGroup");
              if (selectionGroup) {
                this.ungroup(this.selectionGroup);
                this.dataLinks.forEach((link) => {
                  link.moveToTop();
                });
                this.dataLinks = [];
              }
              this.selectionMarkers = [];
              this.schema.clearSelection();
              this.schema.refresh();
              break;
            }

            // this.dataLinks = []
            if (cmd) {
              if (
                e.target.getParent().getType() === "Group" &&
                !e.target.getParent().hasName("selectionGroup")
              ) {
                this.clearSelector();
                let parent = e.target.getParent();
                let isGroup = false;
                const parentOfParent = parent.getParent();
                if (parentOfParent) {
                  isGroup = parentOfParent.getType() === "Group";
                }
                if (isGroup) {
                  parent = parentOfParent;
                }
                this.schema.select("multiple", parent);
                return;
              }
              this.clearSelector();
              this.schema.select("multiple", e.target);
              break;
            }
            if (e.target.getParent().getType() === "Group") {
              let parent = e.target.getParent();
              const getParent = (shape) => {
                const p = shape.getParent();
                if (p.getType() === "Group") {
                  parent = p;
                  return getParent(p);
                } else {
                  return parent;
                }
              };
              const rootParent = getParent(parent);
              this.schema.select("group", rootParent);
            } else {
              if (
                e.target.hasName("selector") ||
                e.target.hasName("attach") ||
                e.target.hasName("marker")
              ) {
                break;
              }
              if (
                e.target.getClassName() === "Arrow" ||
                e.target.getClassName() === "Line" ||
                e.target.getClassName() === "Shape"
              ) {
                this.schema.select("connector", e.target);
              } else {
                this.schema.select("shape", e.target);
              }
              // this.layer.draw()
            }

            break;
          // HERE
          case actions.TEXT:
            shape = new Text(
              createText({
                x,
                y,
                shapeType: "customText",
                text: "Texte par défaut",
              })
            );

            shape.setAttr("id", generateId("customText"));
            this.setDragBoundFunc(shape);
            this.schema.currentLayer.add(shape);
            this.addContextMenuListener(shape, this.contextMenu);
            this.addNodeListener(shape, "dblclick", this._customTextDblclick);
            this.addNodeListener(shape, "transform", () =>
              this._customTextTransform(shape)
            );
            this.setAction(actions.SELECTION);
            this.schema.currentLayer.batchDraw();
            this.schema.updateLayerTree();
            break;
          case actions.RECT:
            for (let j = 0; j < numOfCheckedChekboxes; j++) {
              shape = new Rect(createRect({ x, y, shapeType: "rect" }));
              shape.setAttr("id", generateId("shape"));

              if (selectedEspacesValue[j] !== "") {
                if (selectedEspaces[j]) {
                  selectedEspaces[j].closest("li").classList.add("generated");
                  shape.setAttr("theName", selectedEspacesValue[j]);
                }
              }

              this.setDragBoundFunc(shape);
              this.schema.currentLayer.add(shape);
              this.addContextMenuListener(shape, this.contextMenu);
              this.addNodeListener(shape, "dragmove", this._shapeMove);
              this.addNodeListener(shape, "dragend", this._shapeMoveEnd);
              this.addNodeListener(shape, "transform", this._shapeTransform);
              this.setAction(actions.SELECTION);
              const rectEdges = getShapeEdges(shape, this.stage);
              Object.keys(rectEdges).forEach((key) => {
                createAttachAnchor(
                  rectEdges[key].x,
                  rectEdges[key].y,
                  shape,
                  key
                );
              });
              this.schema.currentLayer.batchDraw();
              this.schema.updateLayerTree();
            }

            break;
          case actions.EYE:
            Image.fromURL(this.eyeUrl, (imageNode) => {
              this.schema.currentLayer.add(imageNode);
              imageNode.setAttrs({
                x,
                y: y - 20,
                width: 40,
                height: 40,
                shapeType: "eye",
                draggable: true,
                id: generateId("eye"),
              });
              this.setDragBoundFunc(imageNode);
              this.setAction(actions.SELECTION);
              this.addContextMenuListener(imageNode, this.contextMenu);
              this.onStateChange(imageNode);
              this.schema.currentLayer.batchDraw();
              this.schema.updateLayerTree();
            });
            break;
          case actions.CIRCLE:
            for (let j = 0; j < numOfCheckedChekboxes; j++) {
              shape = new Circle(createCircle({ x, y, shapeType: "circle" }));
              shape.setAttr("id", generateId("shape"));

              if (
                selectedEspacesValue[j] !== "" &&
                typeof selectedEspaces[j] !== "undefined"
              ) {
                selectedEspaces[j].closest("li").classList.add("generated");
                shape.setAttr("theName", selectedEspacesValue[j]);
              }

              this.setDragBoundFunc(shape);
              this.schema.currentLayer.add(shape);
              this.addContextMenuListener(shape, this.contextMenu);
              this.addNodeListener(shape, "dragmove", this._shapeMove);
              this.addNodeListener(shape, "dragend", this._shapeMoveEnd);
              this.addNodeListener(shape, "transform", this._shapeTransform);
              this.setAction(actions.SELECTION);
              const circleEdges = getShapeEdges(shape, this.stage);
              Object.keys(circleEdges).forEach((key) => {
                createAttachAnchor(
                  circleEdges[key].x,
                  circleEdges[key].y,
                  shape,
                  key
                );
              });
              this.schema.currentLayer.batchDraw();
              this.schema.updateLayerTree();
            }

            break;
          case actions.BDARROW:
            shape = new Konva.Shape(
              createTwoHeadsLineArrow({
                x,
                y,
                width: 100,
                pointerWidth: 10,
                shapeType: "customDoubleArrow",
              })
            );

            shape.getSelfRect = function () {
              const [x, y, x2, y2] = shape.getAttr("points");
              const posy = y2 < y ? y2 : y;
              return {
                x: x,
                y: posy - shape.getAttr("pointerWidth"),
                width: x2 - x,
                height: Math.abs(y2 - y) + shape.getAttr("pointerWidth") * 2,
              };
            };
            this.setDragBoundFunc(shape);
            shape.sceneFunc(function (context, shape) {
              context.beginPath();
              context.moveTo(shape.x(), shape.y());
              const points = shape.getAttr("points");
              drawArrow(
                context,
                points[0],
                points[1],
                points[2],
                points[3],
                shape.getAttr("pointerWidth"),
                "double"
              );
              context.fillStrokeShape(shape);
            });
            shape.setAttr("id", generateId("connector"));
            this.schema.currentLayer.add(shape);
            this.addContextMenuListener(shape, this.contextMenu);
            this.addNodeListener(shape, "dragmove", this._arrowMove);
            this.addNodeListener(shape, "dragend", this._arrowMoveEnd);
            this.setAction(actions.SELECTION);
            this.schema.currentLayer.batchDraw();
            this.schema.updateLayerTree();
            break;
          case actions.ARROW:
            shape = new Konva.Shape(
              createLineArrow({
                x,
                y,
                width: 100,
                shapeType: "customArrow",
                pointerWidth: 10,
              })
            );
            shape.getSelfRect = function () {
              const [x, y, x2, y2] = shape.getAttr("points");
              const posy = y2 < y ? y2 : y;
              return {
                x: x,
                y: posy - shape.getAttr("pointerWidth"),
                width: x2 - x,
                height: Math.abs(y2 - y) + shape.getAttr("pointerWidth") * 2,
              };
            };
            this.setDragBoundFunc(shape);
            shape.sceneFunc(function (context, shape) {
              context.beginPath();
              context.moveTo(shape.x(), shape.y());
              const points = shape.getAttr("points");
              drawArrow(
                context,
                points[0],
                points[1],
                points[2],
                points[3],
                shape.getAttr("pointerWidth")
              );
              context.fillStrokeShape(shape);
            });
            shape.setAttr("id", generateId("connector"));
            this.schema.currentLayer.add(shape);
            this.addContextMenuListener(shape, this.contextMenu);
            this.addNodeListener(shape, "dragmove", this._arrowMove);
            this.addNodeListener(shape, "dragend", this._arrowMoveEnd);
            this.setAction(actions.SELECTION);
            this.schema.currentLayer.batchDraw();
            this.schema.updateLayerTree();

            break;
          case actions.FARROW:
            shape = new Arrow(
              createArrow({ x, y, width: 100, shapeType: "arrow" })
            );
            shape.setAttr("id", generateId("connector"));
            this.setDragBoundFunc(shape);
            this.schema.currentLayer.add(shape);
            this.addContextMenuListener(shape, this.contextMenu);
            this.addNodeListener(shape, "dragmove", this._arrowMove);
            this.addNodeListener(shape, "dragend", this._arrowMoveEnd);
            this.setAction(actions.SELECTION);
            this.schema.currentLayer.batchDraw();
            this.schema.updateLayerTree();

            break;
          case actions.BDFARROW:
            shape = new Arrow(
              createTwoHeadsArrow({
                x,
                y,
                width: 100,
                shapeType: "doubleArrow",
              })
            );
            shape.setAttr("id", generateId("connector"));
            this.setDragBoundFunc(shape);
            this.schema.currentLayer.add(shape);
            this.addContextMenuListener(shape, this.contextMenu);
            this.addNodeListener(shape, "dragmove", this._arrowMove);
            this.addNodeListener(shape, "dragend", this._arrowMoveEnd);
            this.setAction(actions.SELECTION);
            this.schema.currentLayer.batchDraw();
            this.schema.updateLayerTree();
            break;
          case actions.LINE:
            shape = new Line(
              createLine({ x, y, width: 100, shapeType: "line" })
            );
            shape.setAttr("id", generateId("connector"));
            this.setDragBoundFunc(shape);
            this.schema.currentLayer.add(shape);
            this.addContextMenuListener(shape, this.contextMenu);
            this.addNodeListener(shape, "dragmove", this._arrowMove);
            this.addNodeListener(shape, "dragend", this._arrowMoveEnd);
            this.setAction(actions.SELECTION);
            this.schema.currentLayer.batchDraw();
            this.schema.updateLayerTree();

            break;
          case actions.DASHEDARROW:
            shape = new Arrow(
              createDashedArrow({
                x,
                y,
                width: 100,
                shapeType: "dashedArrow",
              })
            );
            shape.setAttr("id", generateId("connector"));
            this.setDragBoundFunc(shape);
            this.schema.currentLayer.add(shape);
            this.addContextMenuListener(shape, this.contextMenu);
            this.addNodeListener(shape, "dragmove", this._arrowMove);
            this.addNodeListener(shape, "dragend", this._arrowMoveEnd);
            this.setAction(actions.SELECTION);
            this.schema.currentLayer.batchDraw();
            this.schema.updateLayerTree();

            break;
          case actions.BDDASHEDARROW:
            shape = new Arrow(
              createDashedTwoHeadsArrow({
                x,
                y,
                width: 100,
                shapeType: "doubleDashedArrow",
              })
            );
            shape.setAttr("id", generateId("connector"));
            this.setDragBoundFunc(shape);
            this.schema.currentLayer.add(shape);
            this.addContextMenuListener(shape, this.contextMenu);
            this.addNodeListener(shape, "dragmove", this._arrowMove);
            this.addNodeListener(shape, "dragend", this._arrowMoveEnd);
            this.setAction(actions.SELECTION);
            this.schema.currentLayer.batchDraw();
            this.schema.updateLayerTree();

            break;
        }

        if (this.currentAction !== actions.SELECTION && shape) {
          this.onStateChange(shape);
        }
      }
    },
    _customTextTransform(node) {
      node.setAttrs({
        width: node.width() * node.scaleX(),
        scaleX: 1,
      });
    },
    _customTextDblclick(e) {
      // hide text node and transformer:
      const node = e.target;
      node.hide();
      node.getLayer().draw();

      this.schema.clearSelection();
      node.getLayer().batchDraw();

      const schema = this.schema;

      let rotation, scale;

      // create textarea over canvas with absolute position
      // first we need to find position for textarea
      // how to find it?

      // at first lets find position of text node relative to the stage:
      const textPosition = node.absolutePosition();

      // then lets find position of stage container on the page:
      const stageBox = this.$refs["canvas"].firstChild.getBoundingClientRect();
      // so position of textarea will be the sum of positions above:
      const areaPosition = {
        x: stageBox.left + textPosition.x + node.padding(),
        y: stageBox.top + textPosition.y + node.padding(),
      };

      // create textarea and style it
      const textarea = document.createElement("textarea");
      document.body.appendChild(textarea);

      // apply many styles to match text on canvas as close as possible
      // remember that text rendering on canvas and on the textarea can be different
      // and sometimes it is hard to make it 100% the same. But we will try...
      textarea.value = node.text();
      textarea.style.position = "absolute";
      textarea.style.top = areaPosition.y + "px";
      textarea.style.left = areaPosition.x + "px";
      textarea.style.width = node.width() - node.padding() * 2 + "px";
      textarea.style.height = node.height() - node.padding() * 2 + 5 + "px";
      textarea.style.fontSize = node.fontSize() + "px";
      textarea.style.border = "none";
      textarea.style.padding = "0px";
      textarea.style.margin = "0px";
      textarea.style.overflow = "hidden";
      textarea.style.background = "none";
      textarea.style.outline = "none";
      textarea.style.resize = "none";
      textarea.style.lineHeight = node.lineHeight();
      textarea.style.fontFamily = node.fontFamily();
      textarea.style.transformOrigin = "left top";
      textarea.style.textAlign = node.align();
      textarea.style.color = node.fill();
      rotation = node.rotation();
      var transform = "";
      if (rotation) {
        transform += "rotateZ(" + rotation + "deg)";
      }

      let px = 0;
      // also we need to slightly move textarea on firefox
      // because it jumps a bit
      const isFirefox =
        navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
      if (isFirefox) {
        px += 2 + Math.round(node.fontSize() / 20);
      }
      transform += "translateY(-" + px + "px)";

      textarea.style.transform = transform;

      // reset height
      textarea.style.height = "auto";
      // after browsers resized it we can set actual value
      textarea.style.height = textarea.scrollHeight + 3 + "px";

      textarea.focus();

      function removeTextarea() {
        textarea.parentNode.removeChild(textarea);
        window.removeEventListener("click", handleOutsideClick);
        node.show();
        /* tr.show()
        tr.forceUpdate() */
        schema.select("shape", e.target);
        node.getLayer().draw();
      }

      function setTextareaWidth(newWidth) {
        if (!newWidth) {
          // set width for placeholder
          newWidth = node.placeholder.length * node.fontSize();
        }
        // some extra fixes on different browsers
        const isSafari = /^((?!chrome|android).)*safari/i.test(
          navigator.userAgent
        );
        const isFirefox =
          navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
        if (isSafari || isFirefox) {
          newWidth = Math.ceil(newWidth);
        }

        const isEdge =
          document.documentMode || /Edge/.test(navigator.userAgent);
        if (isEdge) {
          newWidth += 1;
        }
        textarea.style.width = newWidth + "px";
      }

      textarea.addEventListener("keydown", function (e) {
        // hide on enter
        // but don't hide on shift + enter
        if (e.keyCode === 13 && !e.shiftKey) {
          node.text(textarea.value);
          // removeTextarea()
        }
        // on esc do not set value back to node
        if (e.keyCode === 27) {
          removeTextarea();
        }
      });

      textarea.addEventListener("keydown", function (e) {
        scale = node.getAbsoluteScale().x;
        setTextareaWidth(node.width() * scale);
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + node.fontSize() + "px";
      });

      function handleOutsideClick(e) {
        if (e.target !== textarea) {
          node.text(textarea.value);
          removeTextarea();
          window.removeEventListener("click", handleOutsideClick);
        }
      }
      setTimeout(() => {
        window.addEventListener("click", handleOutsideClick);
      });
    },
    _stageMouseover(evt) {
      if (this.currentAction === actions.SELECTION) {
        if (this.keyMap[17] || this.keyMap[91]) {
          // Ctrl for windows
          if (evt.target.getClassName() === "Stage") {
            document.body.style.cursor = "default";
          } else if (
            evt.target.getLayer()._id !== this.schema.currentLayer._id
          ) {
            document.body.style.cursor = "not-allowed";
          } else if (evt.target.getParent().getType() !== "Group") {
            document.body.style.cursor = "pointer";
          } else if (
            evt.target.getParent().getType() === "Group" &&
            !evt.target.getParent().hasName("selectionGroup")
          ) {
            document.body.style.cursor = "not-allowed";
          }
        } else if (evt.target.getClassName() === "Stage") {
          document.body.style.cursor = "default";
        } else {
          document.body.style.cursor = "pointer";
        }
      }
    },
    _stageMouseout(evt) {
      document.body.style.cursor = "default";
    },
    _arrowMove(e) {
      this.schema.currentLayer
        .find((node) => {
          return node.id() === "start-anchor" || node.id() === "end-anchor";
        })
        .toArray()
        .forEach((el) => {
          const points = e.target.getAttr("points");
          if (el.id() === "start-anchor") {
            el.x(points[0] + e.target.x());
            el.y(points[1] + e.target.y());
          } else {
            el.x(points[2] + e.target.x());
            el.y(points[3] + e.target.y());
          }
        });
      this.schema.currentLayer.batchDraw();
    },
    _groupMove(e) {
      e.target
        .getChildren()
        .toArray()
        .forEach((el) => {
          if (el.id().startsWith("shape")) {
            this.updateAnchors(el);
          }
        });
    },
    _groupMoveEnd(e) {
      this._groupMove(e);
    },
    _arrowMoveEnd(e) {
      const [x, y, x2, y2] = e.target.getAttr("points");
      e.target.setAttr("points", [
        x + e.target.x(),
        y + e.target.y(),
        x2 + e.target.x(),
        y2 + e.target.y(),
      ]);
      e.target.x(0);
      e.target.y(0);
    },
    updateDataLinksPos(links, trans) {
      links.forEach((link) => {
        link.x(link.x() + trans.x);
        link.y(link.y() + trans.y);
      });
    },
    _shapeMove(e) {
      this.updateAnchors(e.target);
      if (this.initialPosition && this.dataLinks.length) {
        const trans = {
          x: e.target.x() - this.initialPosition.x,
          y: e.target.y() - this.initialPosition.y,
        };

        this.initialPosition.x = e.target.x();
        this.initialPosition.y = e.target.y();
        this.updateDataLinksPos(this.dataLinks, trans);
      }
      // this.initGuideLines(e)
    },
    _shapeMoveEnd(e) {
      /* const test = this.stage.findOne('.test')
      if (test) {
        test.destroy()
      } */
      // this.dataLinks.forEach((link) => {
      //   console.log('link =', link);
      //   link.moveToTop();
      // });
      this.schema.currentLayer.find(".guid-line").destroy();
    },
    _shapeTransform(e) {
      this.updateAnchors(e.currentTarget);
      this.debounce(() => this.onStateChange(e.target), 50);
    },
    _selectionMove(e) {
      if (this.initialPosition && this.dataLinks.length) {
        const trans = {
          x: e.target.x() - this.initialPosition.x,
          y: e.target.y() - this.initialPosition.y,
        };
        this.initialPosition.x = e.target.x();
        this.initialPosition.y = e.target.y();
        this.updateDataLinksPos(this.dataLinks, trans);
      }
    },
    _selectionMoveEnd(e) {
      if (this.initialPosition && this.selectionMarkers.length) {
        const trans = {
          x: e.target.x() - this.initialPosition.x,
          y: e.target.y() - this.initialPosition.y,
        };
        this.initialPosition.x = e.target.x();
        this.initialPosition.y = e.target.y();
        this.selectionMarkers.forEach((el) => {
          el.x(el.x() + trans.x);
          el.y(el.y() + trans.y);
          el.visible(true);
        });
        // this.updateDataLinksPos(this.dataLinks, trans)
      }
    },
    _stageMoveStart(_) {
      this.startMoving = true;
    },
    _selectionMoveStart(_) {
      if (this.selectionMarkers.length) {
        this.selectionMarkers.forEach((el) => {
          el.visible(false);
        });
      }
    },
    clearSelector() {
      this.stage
        .find(".selector")
        .toArray()
        .forEach((el) => {
          el.destroy();
        });
    },
    updateAnchors(node) {
      if (!node) return;
      const anchors = node.getAttr("anchors");
      if (!anchors) return;

      const newValues = getShapeEdges(node, this.stage);
      anchors.forEach((anchor) => {
        const coord = newValues[anchor.getAttr("location")];
        anchor.x(coord.x);
        anchor.y(coord.y);
        anchor.moveToTop();
      });
      return this.updateConnectors(node, newValues);
    },
    updateConnectors(node, anchors) {
      let edge, connectorCoord;
      this.stage
        .find((el) => {
          return (
            el.hasName("connector") && (el.getAttr("from") || el.getAttr("to"))
          );
        })
        .forEach((con) => {
          if (
            con.getAttr("from") &&
            con.getAttr("from").id === node.getAttr("id")
          ) {
            const conAttrs = getNodeAttrs(
              con,
              con.getAttr("shapeType"),
              this.stage
            );
            const [, , x, y] = con.getAttr("points");
            connectorCoord = {
              x: conAttrs.x,
              y: conAttrs.y,
            };
            edge = anchors[con.getAttr("from").position];
            con.setAttr("points", [
              edge.x - connectorCoord.x,
              edge.y - connectorCoord.y,
              x,
              y,
            ]);
          } else if (
            con.getAttr("to") &&
            con.getAttr("to").id === node.getAttr("id")
          ) {
            const conAttrs = getNodeAttrs(
              con,
              con.getAttr("shapeType"),
              this.stage
            );
            const [x, y, ,] = con.getAttr("points");
            connectorCoord = {
              x: conAttrs.x,
              y: conAttrs.y,
            };
            edge = anchors[con.getAttr("to").position];
            con.setAttr("points", [
              x,
              y,
              edge.x - connectorCoord.x,
              edge.y - connectorCoord.y,
            ]);
          }
        });
    },
    addContextMenuListener(shape, callback) {
      if (!this.readOnly) {
        shape.on("contextmenu", (e) => {
          e.evt.preventDefault();
          const parent = shape.getParent();
          // if (!parent) return;
          if (
            parent &&
            parent.getType() === "Group" &&
            parent.hasName("selectionGroup")
          ) {
            // do nothing
            e.cancelBubble = true;
          } else if (shape.getType() === "Stage") {
            const stageBox = this.stage.getPointerPosition();
            this.pastePosition = { ...stageBox };
            const menuPosition = {
              x: stageBox.x - this.$refs["canvas"].scrollLeft + "px",
              y: stageBox.y - this.$refs["canvas"].scrollTop + "px",
            };
            this.$refs.contextWrapper.style.top = menuPosition.y;
            this.$refs.contextWrapper.style.left = menuPosition.x;
            this.$refs.contextWrapper.style.position = "absolute";
            callback(e, shape);
            return;
          } else if (parent.getType() === "Group") {
            this.stage.find("Transformer").destroy();
            const parentOfParent = parent.getParent();
            if (parentOfParent.getType() === "Group") {
              this.schema.select("group", parentOfParent);
            } else {
              this.schema.select("group", parent);
            }
            e.cancelBubble = true;
          } else if (
            shape.getClassName() === "Arrow" ||
            shape.getClassName() === "Line" ||
            shape.getClassName() === "Shape"
          ) {
            this.stage.find("Transformer").destroy();
            this.schema.select("connector", shape);
            e.cancelBubble = true;
          } else {
            this.stage.find("Transformer").destroy();
            this.schema.select("shape", shape);
            e.cancelBubble = true;
          }
          const stageBox = this.stage.getPointerPosition();
          const menuPosition = {
            x: stageBox.x - this.$refs["canvas"].scrollLeft + "px",
            y: stageBox.y - this.$refs["canvas"].scrollTop + "px",
          };
          if (!shape.hasName("selector")) {
            shape.getLayer().draw();
          }
          if (this.schema.selection.length > 0) {
            this.$refs.contextWrapper.style.top = menuPosition.y;
            this.$refs.contextWrapper.style.left = menuPosition.x;
            this.$refs.contextWrapper.style.position = "absolute";
            callback(e, shape);
          }
        });
      }
    },
    addNodeListener(node, eventType, callback) {
      if (!this.readOnly) {
        node.on(eventType, callback);
      }
    },
    setShapeContextMenuOptions(item) {
      if (item) {
        let parent = getShapeTopParent(item);
        const isGroup = parent && parent.getType() === "Group";
        if (isGroup && !parent.hasName("selectionGroup")) {
          this.contextMenuOptions = [
            { name: "Dégrouper", action: "ungroup-shapes" },
            { name: "Copier", action: "copy-shape" },
            { name: "Supprimer", action: "remove-shape" },
          ];
        } else if (item.getType() === "Stage") {
          this.contextMenuOptions = [{ name: "Coller", action: "paste-shape" }];
          const childParent = getShapeTopParent(this.schema.selection[0]);

          if (childParent && childParent.getType() === "Group") {
            if (childParent.attrs.id) {
              this.contextMenuOptions = [
                {
                  name: "Dégrouper",
                  action: "ungroup-shapes",
                },
              ];
            } else {
              this.contextMenuOptions = [
                {
                  name: "Grouper",
                  action: "group-shapes",
                },
              ];
            }
          }
          if (this.schema.selection.length) {
            this.contextMenuOptions.push(
              ...[
                { name: "Copier", action: "copy-shape" },
                { name: "Supprimer", action: "remove-shape" },
              ]
            );
          }
        } else {
          const type = item.getAttr("shapeType");
          if (type === "rect" || type === "circle") {
            this.contextMenuOptions = [
              { name: "Copier", action: "copy-shape" },
              { name: "Lier des données", action: "link-data" },
              { name: "Supprimer des liens", action: "delete-link" },
              { name: "Avancer", action: "move-up" },
              { name: "Reculer", action: "move-down" },
              { name: "Supprimer", action: "remove-shape" },
            ];
            if (
              (this.schema.selection.length === 1 &&
                this.schema.selection[0].getType() === "Group" &&
                this.schema.selection[0].children.length > 1) ||
              this.schema.selection.length > 1
            ) {
              this.contextMenuOptions.unshift({
                name: "Grouper",
                action: "group-shapes",
              });
            }
          } else {
            this.contextMenuOptions = [
              { name: "Copier", action: "copy-shape" },
              { name: "Avancer", action: "move-up" },
              { name: "Reculer", action: "move-down" },
              { name: "Supprimer", action: "remove-shape" },
            ];

            if (
              item.parent.getClassName() === "Group" &&
              item.parent.children.length
            ) {
              this.contextMenuOptions.unshift({
                name: "Grouper",
                action: "group-shapes",
              });
            }
          }
        }
      } else {
        this.contextMenuOptions = [];
      }
    },
    setSelectorContextMenuOption() {
      this.contextMenuOptions = [{ name: "Décrocher", action: "decrocher" }];
    },
    selectorContextMenu(event, item) {
      if (!this.readOnly) {
        this.setSelectorContextMenuOption();
        this.$refs.shapeContextMenu.showMenu(event, item);
      }
    },
    contextMenu(event, item) {
      if (!this.readOnly) {
        this.setShapeContextMenuOptions(item);
        this.$refs.shapeContextMenu.showMenu(event, item);
      }
    },
    optionClicked(event) {
      let layer;
      switch (event.option.action) {
        case "group-shapes":
          layer = this.selectionGroup.getLayer();
          const clonedChildren = this.selectionGroup.children.map(
            (node) => node.attrs.id
          );
          for (const id of clonedChildren) {
            this.stage.find((node) => {
              const from = node.getAttr("from");
              const to = node.getAttr("to");
              if ((from && from.id === id) || (to && to.id === id)) {
                const nodeId = node.getAttr("id");
                if (!clonedChildren.includes(nodeId))
                  clonedChildren.push(nodeId);
              }
            });
          }
          this.ungroup(this.selectionGroup);
          const newGroup = new Konva.Group({
            draggable: true,
            listening: true,
            shapeType: "group",
            createdAt: Date.now(),
          });
          setNodeId(newGroup);
          this.addNodeListener(newGroup, "dragmove", this._groupMove);
          this.addNodeListener(
            newGroup,
            "dragend transform",
            this._groupMoveEnd
          );
          layer.add(newGroup);
          newGroup.moveToTop();
          let selection = [];

          let isGroup =
            this.schema.selection.length === 1 &&
            this.schema.selection[0].getType() === "Group";

          if (isGroup) {
            selection = clonedChildren
              .map(
                (nodeId) =>
                  this.stage.find((node) => {
                    if (node.getAttr("id") === nodeId) {
                      return node;
                    }
                  })[0]
              )
              .filter((node) => node !== null && node !== undefined)
              .concat(this.dataLinks);
          } else {
            selection = [];
            const existedList = {};
            this.schema.selection.forEach((selectedShape) => {
              selection.push(selectedShape);
              existedList[selectedShape.getAttr("id")] = true;
              const linkedData = this.stage
                .find(
                  (node) =>
                    node.getAttr("linkTo") === selectedShape.getAttr("id")
                )
                .toArray();
              if (linkedData.length) {
                selection.push(...linkedData);
              }
              return linkedData;
            });

            this.stage.find((node) => {
              const nodeId = node.getAttr("id");
              const notSelectedYet =
                clonedChildren.indexOf(nodeId) > -1 && !existedList[nodeId];
              if (notSelectedYet) {
                selection.push(node);
              }
            });
          }
          selection.forEach((el) => {
            el.off("dragmove dragend transform");
            el.setAttr("draggable", false);
            newGroup.add(el);
          });
          this.schema.selection = selection;
          this.stage.find("Transformer").destroy();
          this.dataLinks = [];
          this.selectionMarkers = [];
          this.schema.clearSelection();
          this.schema.updateLayerTree();
          layer.draw();
          window.mustUngroup = false;
          this.onStateChangeWithGroup(newGroup, selection);
          break;
        case "ungroup-shapes":
          layer = event.item.getParent().getLayer();
          let parent = event.item.getParent();
          const rootParent = (shape) => {
            const topParent = shape.getParent();
            if (topParent.getType() === "Group") {
              parent = topParent;
              return rootParent(topParent);
            }
            return parent;
          };
          parent = rootParent(parent);
          const ungroupSelection = parent.children.slice(0);
          this.onUngroup(parent, layer, ungroupSelection);
          this.onStateChangeWithUngroup(parent, ungroupSelection);
          layer.draw();
          break;
        case "decrocher":
          if (event.item.getAttr("id") === "end-anchor") {
            event.item.getAttr("target").setAttr("to", null);
          } else {
            event.item.getAttr("target").setAttr("from", null);
          }
          this.clearSelector();
          break;
        case "link-data":
          this.$refs["linkModal"].open(event.item.getAttr("id"));
          break;
        case "move-up":
          this.schema.moveUp(event.item);
          break;
        case "move-down":
          this.schema.moveDown(event.item);
          break;
        case "delete-link":
          const data = this.findLink(event.item).map((el) => {
            const { idTableau, key, rowNo, id } = el.getAttrs();
            const tdata = this.getTableauData(idTableau, key, rowNo);
            return {
              id,
              ...tdata,
            };
          });
          if (!data.length) return;
          this.$refs["deleteLinkModal"].open(data);
          break;
        case "remove-shape":
          this.schema.selection.forEach((element) => {
            this._onDeleteNode(element);
            this.schema.deleteNode(element);
          });
          // const parentRoot = getShapeTopParent(event.item);
          // this._onDeleteNode(parentRoot);
          // this.schema.deleteNode(parentRoot);
          break;
        case "copy-shape":
          let node;
          const _topParent = (shape) => {
            const topParent = shape.getParent();
            if (topParent.getType() === "Group") {
              node = topParent;
              return _topParent(topParent);
            }
            return shape;
          };
          node = _topParent(event.item);
          this.copiedObject = {
            node: mapShapeToState(node, 10),
            layer: node.getLayer(),
            margin: 10,
          };
          break;
        case "paste-shape":
          if (!this.copiedObject) return;
          const name = this.copiedObject.node.attrs.name;
          let shapes;
          if (name === "selectionGroup") {
            shapes = this.copiedObject.node.children;
          } else {
            shapes = [this.copiedObject.node];
          }
          shapes = shapes.map((node) => {
            const shape = this.renderShape(node, !this.readOnly, true);
            shape.attrs.createdAt = Date.now();
            this.copiedObject.layer.add(shape);
            this.setRenderredShapedEvents(shape, this.stage);
            this.schema.updateLayerTree();
            return shape;
          });

          this.onStateChange(shapes);
          this.copiedObject.layer.draw();
          break;
      }
    },
    findLink(node) {
      const { shapeType: type, id } = node.getAttrs();

      if (type === "rect" || type === "circle") {
        return this.stage
          .find((el) => {
            return el.getAttr("linkTo") + "" === id + "";
          })
          .toArray();
      }
      return null;
    },
    deleteShape(node) {
      const { shapeType: type } = node.getAttrs();
      if (type === "rect" || type === "circle") {
        this.findLink(node).forEach((el) => {
          el.destroy();
        });
      }
      const layer = node.getLayer();
      node.destroy();
      this.clearSelector();
      this.stage.find("Transformer").destroy();
      this.schema.updateLayerTree();
      layer.draw();
    },
    ungroup(group, draggable = true) {
      const children = group.getChildren();
      const layer = group.getLayer();
      children.toArray().forEach((e) => {
        const matrix = e.getAbsoluteTransform().getMatrix();
        const attrs = decompose(matrix);
        e.setAttr("draggable", draggable);
        e.moveTo(layer);
        e.setAttrs(attrs);
        if (e.id().startsWith("shape")) {
          this.updateAnchors(e);
        }
      });
      group.destroy();
    },
    createSelector(x, y, target, type) {
      const selector = new Circle({
        id: type,
        x,
        y,
        target,
        radius: 5,
        stroke: "#666",
        fill: "#ddd",
        strokeWidth: 2,
        draggable: true,
        name: "selector",
      });

      const _this = this;
      let attachTo, targetCoord;
      const layer = target.getLayer();

      this.addContextMenuListener(selector, this.selectorContextMenu);

      selector.on("mouseover", function () {
        this.setOpacity(0.8);
        this.stroke("blue");
        layer.draw();
      });

      selector.on("mouseout", function () {
        this.setOpacity(1);
        this.stroke("#666");
        layer.draw();
      });

      selector.on("dragmove", function () {
        const selectorRect = selector.getClientRect();
        targetCoord = {
          x: selector.getAttr("target").getAttr("x"),
          y: selector.getAttr("target").getAttr("y"),
        };

        if (selector.id() === "start-anchor") {
          const [, , x2, y2] = selector.getAttr("target").getAttr("points");
          this.getAttr("target").setAttr("points", [
            selector.x() - targetCoord.x,
            selector.y() - targetCoord.y,
            x2,
            y2,
          ]);
        } else {
          const [x1, y1, ,] = selector.getAttr("target").getAttr("points");
          this.getAttr("target").setAttr("points", [
            x1,
            y1,
            selector.x() - targetCoord.x,
            selector.y() - targetCoord.y,
          ]);
        }

        function isNear(selector, shape) {
          const near = haveIntersection(
            shape.getClientRect(),
            selector.getClientRect(),
            20
          );
          if (near) {
            return shape.getAttr("anchors").map((el) => {
              el.visible(true);
              return el;
            });
          } else {
            shape.getAttr("anchors").forEach((el) => {
              el.visible(false);
            });
            return null;
          }
        }

        _this.stage
          .find((node) => {
            return node.id().startsWith("shape");
          })
          .toArray()
          .some((el) => {
            if (el === selector) {
              return;
            }
            const anchors = isNear(selector, el);
            if (!anchors) {
              return false;
            }
            return anchors.some((anch) => {
              const haveInter = haveIntersection(
                anch.getClientRect(),
                selectorRect
              );
              if (haveInter) {
                anch.setOpacity(0.5);
                anch.stroke("green");
                anch.radius(8);
                attachTo = anch;
                return true;
              } else {
                if (anch.setOpacity) {
                  anch.setOpacity(1);
                  anch.stroke("red");
                  anch.radius(2);
                  attachTo = null;
                  return false;
                }
              }
            });
          });
      });

      selector.on("dragend", function () {
        if (attachTo) {
          attachTo.setOpacity(1);
          targetCoord = {
            x: selector.getAttr("target").getAttr("x"),
            y: selector.getAttr("target").getAttr("y"),
          };
          if (selector.id() === "start-anchor") {
            selector.getAttr("target").setAttr("from", {
              id: attachTo.getAttr("nodeId"),
              position: attachTo.getAttr("location"),
            });
            const [, , x, y] = selector.getAttr("target").getAttr("points");
            selector
              .getAttr("target")
              .setAttr("points", [
                attachTo.x() - targetCoord.x,
                attachTo.y() - targetCoord.y,
                x,
                y,
              ]);
            selector.x(attachTo.x());
            selector.y(attachTo.y());
          } else {
            const [x, y, ,] = selector.getAttr("target").getAttr("points");
            selector.getAttr("target").setAttr("to", {
              id: attachTo.getAttr("nodeId"),
              position: attachTo.getAttr("location"),
            });
            selector
              .getAttr("target")
              .setAttr("points", [
                x,
                y,
                attachTo.x() - targetCoord.x,
                attachTo.y() - targetCoord.y,
              ]);
            selector.x(attachTo.x());
            selector.y(attachTo.y());
          }
        }
        _this.onStateChange(target);
        layer.batchDraw();
      });
      layer.add(selector);
    },
    haveIntersection(r1, r2, margin = 0) {
      return haveIntersection(r1, r2, margin);
    },
    showAttachAnchors(value) {
      this.stage
        .find(".attach")
        .toArray()
        .forEach((el) => {
          el.visible(value);
        });
    },
    drawGuides(guides) {
      guides.forEach((lg) => {
        if (lg.orientation === "H") {
          const line = new Konva.Line({
            points: [-6000, lg.lineGuide, 6000, lg.lineGuide],
            stroke: "rgb(0, 161, 255)",
            strokeWidth: 1,
            name: "guid-line",
            dash: [4, 6],
          });
          this.schema.currentLayer.add(line);
          this.schema.currentLayer.batchDraw();
        } else if (lg.orientation === "V") {
          const line = new Konva.Line({
            points: [lg.lineGuide, -6000, lg.lineGuide, 6000],
            stroke: "rgb(0, 161, 255)",
            strokeWidth: 1,
            name: "guid-line",
            dash: [4, 6],
          });
          this.schema.currentLayer.add(line);
          this.schema.currentLayer.batchDraw();
        }
      });
    },
    _stageDragMove(e) {
      this.stage.find(".guid-line").destroy();
      if (e.target.hasName("selector")) return;
      const lineGuideStops = getLineGuideStops(e.target, this.stage);
      const itemBounds = getObjectSnappingEdges(e.target, this.stage);
      const guides = getGuides(
        lineGuideStops,
        itemBounds,
        this.GUIDELINE_OFFSET
      );
      if (!guides.length) {
        return;
      }
      this.drawGuides(guides);
      guides.forEach((lg) => {
        switch (lg.snap) {
          case "start":
          case "center":
          case "1/3":
          case "2/3":
          case "end":
            const coorodinate = lg.lineGuide + lg.offset;
            switch (lg.orientation) {
              case "V":
                e.target.x(coorodinate);
                break;
              case "H":
                e.target.y(coorodinate);
                break;
            }
            break;
        }
      });
      this.startMoving = true;
    },
    _stageDragEnd(_) {
      this.stage.find(".guid-line").destroy();
      if (this.startMoving) {
        const { selection } = this.schema;
        this._onSelectionChanged(selection);
        this.startMoving = false;
      }
      this.schema.refresh();
    },
  },
};
</script>

<style lang='scss'>
#canvas {
  overflow: auto;
  width: 100%;
  text-align: center;
  background-color: #e9eaf3;
  border: 1px solid #2b3085;
  padding-top: 30px;
  padding-bottom: 30px;
  .konvajs-content {
    margin: auto;
    background-color: white;
    -webkit-box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.48);
    -moz-box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.48);
    box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.48);
  }
}
.vue-simple-context-menu {
  &--active {
  }
  &__item {
    white-space: nowrap;
    &:hover {
    }
  }
}
/*  #canva-wrapper {
    overflow: auto;
    width: 100%;
    height:100%;
    text-align:center;
    position:relative;
    background-color: #e9eaf3;
    border: 1px solid #2b3085;
    padding-top: 30px;
    padding-bottom: 30px;
    .konvajs-content{
      width:100% !important;
      height:100% !important;
      margin: auto;
      background-color: white;
      -webkit-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.48);
      -moz-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.48);
      box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.48);
    }
  }
  .vue-simple-context-menu {

    &--active {
    }
    &__item {
      white-space: nowrap;
      &:hover {
      }
    }
  }

  #canvas {
    height: 100% !important;
    width: 100%;
    margin: 0 auto;
    resize: auto;
    overflow: hidden;
  }
  canvas {
    height: 100% !important;
    width: 100%!important;
  }
  .resizable-component {
    left:16% !important;
  }
  #canva-wrapper .arrow {
    border: solid black;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 3px;
  }

  #canva-wrapper .right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  #canva-wrapper .left {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }

  #canva-wrapper .up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }

  #canva-wrapper .down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }

  .resizable-t {
    height:15px !important;
    top:-20px !important;
  }

  .resizable-l {
    width:15px !important;
    left: -16px !important;
  }

  .resizable-r {
    width:15px !important;
  }

  .resizable-b {
    height:15px !important;
    bottom:-10px !important;
  }

  .right {
    top:50%;
    left: 950px;
  }

  .resize-btn {
    height:15px;
    line-height: 10px;
    border-color:#2b3085;
    border: 1px solid;
  }

  .resize-top-btn {
    border-bottom:none;
    cursor:n-resize !important;
  }

  .resize-left-btn {
    height:20px;
    width:15px;
    position:absolute;
    left: 0;
    line-height:0;
    top:50% !important;
    border-right:none;
    cursor:w-resize !important;
  }

  .resize-right-btn {
    height:20px;
    width:15px;
    right: -9px;
    top:50% !important;
    position:absolute;
    border-left:none;
    line-height:0;
    cursor:e-resize !important;
    padding-left: 1px;
  }

  .resize-bottom-btn {
    height:15px;
    width:20px;
    border-top:none;
    padding-top:1px !important;
    cursor:s-resize !important;
    line-height:0;
  }*/
</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/schemaCanvas.vue